import React from "react";
import { Popup } from 'witmeg-ui-system';
import "./SoldoutModal.scss"


const SoldoutModal = ({ visibility, onPopupClose, headerText, subText, btnText = "OK" }) => {
    return (
        <Popup
            className='SoldoutModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={onPopupClose}
            closable={false}>
            <div className="SoldoutModal-inner">
                <div className="SoldoutModal-header-text">{headerText}</div>
                <div className="SoldoutModal-sub-text">{subText}</div>
                <div className="btn-container" onClick={onPopupClose}>{btnText}</div>
            </div>
        </Popup>
    )
}
export default SoldoutModal